module.exports = __webpack_public_path__ + "static/media/ellipse-icon.e5adde44.png";